import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnPN: CultureInfo = {
  name: 'en-PN',
  displayName: 'English (Pitcairn Islands)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-PN',
  parent: CultureInfoEn
};
